import { ActionCreatorsMapObject, bindActionCreators } from '@reduxjs/toolkit'
import { useMemo } from 'react'

import { useAppDispatch } from './hooks'

export function createActionsHook() {
  return function useActions<TActions extends ActionCreatorsMapObject>(
    actions: TActions
  ): TActions {
    const dispatch = useAppDispatch()

    const boundActions = useMemo(() => bindActionCreators(actions, dispatch), [actions, dispatch])

    return boundActions
  }
}

export const useActions = createActionsHook()
